module.exports = __webpack_public_path__ + "static/media/Colette King Bed Base - 180x210 cm_Burnt Orange.45c030de.png";